<template>
  <div>
    <div @click="selector_box_show = true" class="selbtn">
      <span v-if="selectorobj.materialName">{{
        selectorobj.materialName
      }}</span>
      <span v-if="selectorobj.key">{{ selectorobj.key }}</span>
      <span><i class="iconfont icon-out-column"></i>选择动作</span>
    </div>
    <div class="selector_box" v-if="selector_box_show">
      <div class="selector_box_content">
        <component
          v-bind:is="ActionName"
          :t9render="t9render"
          :user="user"
          @selector="selector"
        ></component>

        <div class="selector_box_close" @click="selector_box_show = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import TabAction from '../role/menu/TabAction.vue'

export default {
  name: 'Material',
  props: {
    user: {
      type: Object,
      default: function () {
        return {}
      }
    }
    ,
    t9render: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    TabAction: () => import(/*webpackChunkName:"TabAction"*/'@//views/role/menu/TabAction.vue'),
  },
  created () {
    // console.log('Material created', this.user)
  },
  data () {
    return {
      ActionName: "TabAction",
      selector_box_show: false,//窗口显示隐藏
      selectorobj: {}
    }
  },
  methods: {
    selector (obj) {
      //  console.log(obj);
      this.selector_box_show = false
      this.selectorobj = obj
      this.$emit('selector', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>